import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
    // GridColumnVisibilityModel,
    // GridColTypeDef,
    GridValueFormatterParams
} from "@mui/x-data-grid";
import { Box, Button, Typography } from "@mui/material";
import { staff } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";
import { getBranches } from "../services/get.service";
import { Link } from "react-router-dom";

const Branches = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [rows, setRows] = useState<Array<staff>>([])

    useEffect(() => {
        setLoading(true);

        getBranches()
            .then((res) => {
                setLoading(false);
                setRows(res.data)
            })
            .catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }, [setRows]);

    const columns: GridColDef[] = [
        { field: 'name', headerName: "Name", width: 170 },
        { field: 'shortName', headerName: "Short Name", width: 170 },
        {
            field: 'createdAt', headerName: "Registered Date", width: 170, type: "dateTime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                return new Date(val.value).toDateString()
            }
        },
        { field: 'ownerId', headerName: "Meleyo", width: 170 },
    ]

    return <>
        <Helmet>
            <title>Branches</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full px-3 lg:px-20 py-10 pt-5">
                    <Button variant="contained"><Link to="/create/branch">Add New</Link></Button>
                    <Typography variant="h4" fontSize={32} className="py-3">Branches</Typography>
                    <Box sx={{ height: 520, width: "100%" }}>
                        {loading ?
                            (
                                <ClipLoader loading={loading} size={70} />
                            )
                            :
                            (
                                rows !== undefined && rows.length > 0 ?
                                    (
                                        <DataGrid rows={rows} onRowClick={(r) => console.log(r.id)
                                        } columns={columns} slots={{ toolbar: GridToolbar }}/>
                                    )
                                    :
                                    <DataGrid rows={[]} columns={columns} />
                            )
                        }
                    </Box>
                </div>
            </div>
        </div>
    </>;
};

export default Branches;
